import { SELECTED_RING_LOCAL_STORAGE_KEY } from '../FeatureFlagLocalStorageConstants';
import { FlightConfig } from '../store/schema/NinjaFlightsResponse';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import onFeatureFlagsPaneOpened from '../actions/onFeatureFlagsPaneOpened';
import onFlightsApiResponseProcessed from '../actions/onFlightsApiResponseProcessed';
import onFlightConfigSelected from '../actions/onFlightConfigSelected';
import { getItem } from 'owa-local-storage';

mutator(onFeatureFlagsPaneOpened, () => {
    getStore().selectedFlightConfig =
        (getItem(window, SELECTED_RING_LOCAL_STORAGE_KEY) as FlightConfig) || 'DEFAULT';
});

mutator(onFlightsApiResponseProcessed, actionMessage => {
    const { dogfoodFlights, microsoftFlights, wwFlights } = actionMessage;

    getStore().dogfoodFlights = dogfoodFlights;
    getStore().microsoftFlights = microsoftFlights;
    getStore().wwFlights = wwFlights;
});

mutator(onFlightConfigSelected, actionMessage => {
    getStore().selectedFlightConfig = actionMessage.flightConfig;
});
